import { createParseContext } from "../utility/ParseContext.js";
import { parseNewHeader } from "./newHeader.js";
import { parseOldHeader } from "./oldHeader.js";
import { parseFlagParameters } from "./utility/headerUtilities.js";
/**
 * File-header parsing - First 512/256 bytes (new/old format).
 * @param buffer - SPC buffer.
 * @param context - shared parse state (encoding, warnings).
 * @returns File-header object.
 */
export function fileHeader(buffer, context = createParseContext()) {
    const parameters = parseFlagParameters(buffer.readUint8());
    const fileVersion = buffer.readUint8(); // 4B/4C => new format; 4D => LabCalc
    switch (fileVersion) {
        case 0x4b:
            break;
        case 0x4c:
            buffer.setBigEndian();
            break;
        case 0x4d:
            return parseOldHeader(buffer, parameters, fileVersion, context);
        default:
            throw new Error('Unrecognized file format: byte 01 must be either 4B, 4C or 4D');
    }
    return parseNewHeader(buffer, parameters, fileVersion, context);
}
//# sourceMappingURL=fileHeader.js.map